<ng-container *appTranslate="let t">
  @if (showSidebar) {
    <p-dialog
      [(visible)]="showSidebar"
      [header]="t('userFeedback.create')"
      [modal]="true"
      styleClass="w-overlay"
      appendTo="body"
      (onHide)="close()"
    >
      <new-ui-user-feedback-edit-dialog [disabled]="disabled" (saved)="save($event)" (closed)="close()" />
    </p-dialog>
  }
</ng-container>
